import styled from "styled-components"
import { RestrictUserAccess } from "@utils/helpers"
import { GenericButton } from "shared/ui-basics"

export const WrapperGrid = styled.div`
    :hover{
        .drag-handle-child{
            display:flex;
            align-items:center;
        }
    }
`
export const Handle = styled.div`

    cursor: grab;
    touch-action: manipulation;
    user-select: none;
    display: none;
    justify-content: center;
    padding: 0.2rem;

    svg {

width: 20px;
height: 20px;
}
`
export const ActionsBox = styled.div`
    position: relative;
    top: 0;
    right: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    height: 100%;
    /* background-color: #FFFFFF; */
    color: #605F60 !important;
    display: none;
    font-size: 1.5rem;
    max-height:38px;
        padding: 0.2rem;
    ${props => props.access ? 'visibility:hidden': ''}
`
export const Container = styled.div`
    position: relative;
    border-radius: 4px;
    background-color: '#fff';
    margin-bottom: 0.5rem;
    width: 100%;
    border: ${props => props.isDragging ? '1px solid #f6f6f6' : ''};
    :hover {
        ${Handle} {
        display:flex;
    }
    ${ActionsBox} {
        display: flex;
    }

    }

`

export const ListItem = styled.div`
    min-height: 38px;
    background-color: ${props => props.colorCode?.length !== 0 ? props.colorCode : '#FFFFFF'};
    margin-bottom: 0.25rem;
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
    justify-content: center;
    border-radius: 4px;
    border: ${props => ['#ffffff','#FFFFFF'].includes(props.colorCode) || props.colorCode?.isEmptyString() ||  props.colorCode === null? '1px solid #c4c4c4': 'none'};
    ${props => props.colorCode?.length > 15 && props.colorCode};

`
export const AddButton = styled.button`
border-radius: 0;
height: 30px;
color: black;
visibility: ${props => !props.hide ? 'hidden' : 'inherit'} ;;
color: #F96209;
background-color: #FFFFFF;
border: 1px solid #F96209;
border-radius: 2px;
width: 100%;
padding: 0 10px;
font-weight: 500;

&:hover {
  background-color: #F96209;
  color: #FFFFFF;
}
`
export const AddListItem = styled.div`
border-radius: 0;
min-height: 38px;
  color: #333333;
  align-self:center;
height:max-content;
border-radius: 4px;
padding: 6px;

border: 1px dashed #C4C4C4;  background-color: #FFFFFF !important;

  visibility: ${props => props.hide ? 'hidden' : 'inherit'} ;;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;

  ${props => RestrictUserAccess(props.access?.toLowerCase(),['viewer']) ? ' pointer-events: none !important;' :''};
  display: grid;
  align-items: center;


  `
export const Text = styled.div`
background-color: transparent !important;
    color: #333333 !important;
    padding: 8px;
    z-index: 0;
    overflow: visible;
    border-radius: 0;
    font-size: 14px;
    min-height: inherit;
    line-height: 1.58rem;
`
export const  Card = styled.div`

padding: 0.5rem;
border-radius: 4px;
box-shadow: 0 0 0 1px #c4c4c4;
`
export const SectionTitle = styled.div`
padding: 0.5rem;
border-radius: 4px;
color : #333333;
font-size: 16px;
`
export const WhiteContainer = styled.div`
background-color: #FFFFFF;
border-radius: 4px;
padding: 0.5rem;
width: 100%;
height: 100%;
`
export const TextInfo = styled.div`
font-size: 14px;
font-weight: 400;
color: #333333;
border-radius: 4px;
background: #EFEFEF;
color: #605F60;
padding: 8px;
width: 100%;

font-family: Inter;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 150%;
`

export const ButtonAddListItem=styled(GenericButton)`
${(props)=>props?.ishidden==="true"?`visibility: hidden;
`:`visibility:visible;`}

`